export const constMap = {
    "searchForm": {
        "agechi": { maxlength: 2 },
        "area": { maxlength: 2 },
        "bank-branch": { maxlength: 4 },
        "biko": { maxlength: 2 },
        "chohyo": { maxlength: 4 },
        "department": { maxlength: 4 },
        "deposit-dealing": { maxlength: 2 },
        "gate": { maxlength: 2 },
        "inside-warehouse": { maxlength: 2 },
        "item": { maxlength: 7 },
        "classification": { maxlength: 4 },
        "maker": { maxlength: 3 },
        "payment-dealing": { maxlength: 2 },
        "roll": { maxlength: 4 },
        "root": { maxlength: 3 },
        "sales-dealing": { maxlength: 2 },
        "selling-dealing": { maxlength: 2 },
        "sire-dealing": { maxlength: 2 },
        "siresaki": { maxlength: 6 },
        "stocks-dealing": { maxlength: 2 },
        "tantosha": { maxlength: 4 },
        "tokuisaki": { maxlength: 6 },
        "unit": { maxlength: 2 },
        "warehouse": { maxlength: 4 },
        "denpyobunrui": { maxlength: 4 },
        "jseki-jken": { maxlength: 6 },
        "jicfs-bnri": { maxlength: 6 },
        "shin-sbtu": { maxlength: 2 },
        "hachuski": { maxlength: 6 },
        "hso-kiti": { maxlength: 2 },
        "hachuski-kngn": { maxlength: 6 },
        "company-bankno": { maxlength: 1 },
        "demand-no": { maxlength: 8 },
        "denpyo-cd": { maxlength: 2 },
        "deposit-no": { maxlength: 8 },
        "estimate-no": { maxlength: 8 },
        "hchu-no": { maxlength: 7 },
        "juchu-no": { maxlength: 8 },
        "nohin-no": { maxlength: 8 },
        "nyuka-no": { maxlength: 7 },
        "nyu-shuko-no": { maxlength: 8 },
        "payment-calculation-no": { maxlength: 8 },
        "payment-no": { maxlength: 8 },
        "siire-no": { maxlength: 7 },
        "sykasszu-no": { maxlength: 4 },
        "jchuhead": { maxlength: 8 },
        "jken-dnpyo-no": { maxlength: 8 },
        "rreki-fax-juchuno": { maxlength: 8 },
        "aite-item": { maxlength: 14 },
        "aite-tokuisaki": { maxlength: 10 },
        "sire-unit-price": { maxlength: 10 },
        "sales-unit-price": { maxlength: 10 },
        "nhnski": { maxlength: 6 },
    },
    "btnView": {
        yes: "はい",
        no: "いいえ",
        ins: "登録",
        upd: "修正",
        del: "削除",
        copy: "複製",
        menu: "メニュー",
        rirekiShokai: "履歴照会",
        faxjchuShokai: "ＦＡＸ受注照会",
        search: "検索",
        searchf4: "検索(F4)",
        zikoShokai: "在庫照会",
        eosConvErrorShokai: "ＥＯＳ変換エラー照会",
        eosNhnymdShokai: "ＥＯＳ納品日照会",
        suiimkktiShokai: "推移未確定照会",
        htSirmkktiShokai: "ＨＴ仕入未確定照会",
        tnbanRrkShokai: "棚番履歴照会",
        yoZikoShokai: "預在庫照会",
        csv: "ＣＳＶ出力",
        detail: "詳細",
        checkList: "チェックリスト印刷",
        clear: "クリア",
        pdf: "ＰＤＦプレビュー",
        // さすがWebではキャンセルを以下のように設定
        cancel: "終了",
        print: "印刷",
        commit: "確定",
        dialogCancel: "Cancel",
        end: "終了",
        back: "戻る",
        dialogOk: "OK"
    },
    "btnShortcut": {
        "メニュー": "F1",
        "検索": "F3",
        "検索(F4)": "F4",
        "在庫照会": "F4",
        "EOS変換エラー照会": "F4",
        "ＥＯＳ変換エラー照会": "F4",
        "EOS納品日照会": "F4",
        "ＥＯＳ納品日照会": "F4",
        "推移未確定照会": "F4",
        "HT仕入未確定照会": "F4",
        "ＨＴ仕入未確定照会": "F4",
        "棚番履歴照会": "F4",
        "預在庫照会": "F3",
        "CSV出力": "F9",
        "ＣＳＶ出力": "F9",
        "詳細": "F9",
        "チェックリスト印刷": "F9",
        "クリア": "F10",
        "PDFプレビュー": "F10",
        "ＰＤＦプレビュー": "F10",
        // さすがWebではキャンセル(F11)を以下のように設定
        "終了": { "F": "ESC", "R": "ESC" },
        "戻る": { "F": "ESC", "R": "ESC" },
        "印刷": "F12",
        "Cancel": "ESC",
        "確定": "F12",
        "OK": "F12"
    },
    "keynameCode": {
        "Tab": 9,
        "Enter": 13,
        "F1": 112,
        "F2": 113,
        "F3": 114,
        "F4": 115,
        "F5": 116,
        "F6": 117,
        "F7": 118,
        "F8": 119,
        "F9": 120,
        "F10": 121,
        "F11": 122,
        "F12": 123,
        "ESC": 27
    },
    "format": {
        yyyymmddhhmmss: "yyyy/MM/dd hh:mm:ss",
        yyyymmdd: "yyyy/MM/dd",
        yyyymm: "yyyy/MM"
    },
    "components": {
        textbox: "textbox",
        checkbox: "checkbox",
        selectbox: "selectbox",
        button: "button"
    },
    "dispCountKbn": [3000, 4000, 5000],
    "dispCountSpecialKbn": [3000, 4000, 5000],
}

export default constMap;